import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  CircularProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CheckCircleOutlineIcon } from 'icons/materialIcons';

const AccessorySuccess = ({ cardId }) => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);
  const cardUrl = `/card/${cardId}?source=accessory`;

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate(cardUrl);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate, cardUrl]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#fff',
        padding: '20px'
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '440px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3
        }}
      >
        <CheckCircleOutlineIcon
          sx={{
            fontSize: 64,
            color: '#4CAF50'
          }}
        />

        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
            color: '#000',
            textAlign: 'center'
          }}
        >
          Device Activated Successfully!
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: '#666',
            textAlign: 'center',
            fontSize: '1rem',
            maxWidth: '320px',
            marginTop: '-8px'
          }}
        >
          This card has been mapped successfully with your Digital card.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: '#666',
            textAlign: 'center',
            fontSize: '1rem',
            maxWidth: '320px'
          }}
        >
          Scan your card on your mobile phone to load your Digital card.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            marginTop: 2
          }}
        >
          <CircularProgress size={16} />
          <Typography
            variant="body2"
            sx={{ color: '#666' }}
          >
            Redirecting in {countdown} seconds...
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AccessorySuccess;